import request from "../../utils/request";

export function getSettings() {
  return request({
    url: "/settings",
    method: "get"
  });
}

export function updateSetting(key, data) {
  return request({
    url: `/settings/${key}`,
    method: "put",
    data
  });
}

export function getOpeningPrompts() {
  return request({
    url: "/settings/opening-prompts",
    method: "get"
  });
}

export function createOpeningPrompt(data) {
  return request({
    url: "/settings/opening-prompts",
    method: "post",
    data
  });
}

export function updateOpeningPrompt(id, data) {
  return request({
    url: `/settings/opening-prompts/${id}`,
    method: "put",
    data
  });
}

export function deleteOpeningPrompt(id) {
  return request({
    url: `/settings/opening-prompts/${id}`,
    method: "delete"
  });
}

export function getMediaLibrary(params) {
  return request({
    url: "/settings/media-library",
    method: "get",
    params,
    timeout: 60000
  });
}

export function getMediaSalesOptions() {
  return request({
    url: "/settings/media-library/sales-options",
    method: "get"
  });
}

export function createMediaFolder(data) {
  return request({
    url: "/settings/media-library/folders",
    method: "post",
    data
  });
}

export function updateMediaFolder(id, data) {
  return request({
    url: `/settings/media-library/folders/${id}`,
    method: "put",
    data
  });
}

export function deleteMediaFolder(id) {
  return request({
    url: `/settings/media-library/folders/${id}`,
    method: "delete"
  });
}

export function uploadMediaImage(data) {
  return request({
    url: "/settings/media-library/images",
    method: "post",
    data,
    timeout: 120000
  });
}

export function updateMediaImage(id, data) {
  return request({
    url: `/settings/media-library/images/${id}`,
    method: "put",
    data
  });
}

export function deleteMediaImage(id) {
  return request({
    url: `/settings/media-library/images/${id}`,
    method: "delete"
  });
}

export function exportMediaLinks(params) {
  return request({
    url: "/settings/media-library/export-links",
    method: "get",
    params,
    responseType: "blob",
    timeout: 120000
  });
}
